<div class="preferences-overview wrapper--spacing-horizontal" data-test="preferences-overview">
  <h1 class="text--h1">{{ 'preferences.preferences-overview.title' | translate }}</h1>
  <p>{{ 'preferences.preferences-overview.description' | translate }}</p>
  <mat-divider></mat-divider>

  <div class="preferences-overview__groups spacing--padding-top" *ngIf="(preferenceGroups$ | async)?.length; else noPreferenceGroups">
    <div class="preferences-overview__group flex--row" *ngFor="let preferenceGroup of preferenceGroups$ | async" data-test="preference-group">
      <p class="preferences-overview__preference-group-title text--bold flex--justify-start">
        {{ preferenceGroup.displayName || preferenceGroup.groupKey }}
      </p>

      <div class="preferences-overview__preference flex--column">
        <div *ngFor="let preference of preferenceGroup?.subGroups">
          <p>{{ preference.displayName || preference.subGroupKey }}</p>

          <ng-container *ngFor="let deliveryOption of preference.methods">
            <mat-slide-toggle
              data-test="preference-group-deliver-options"
              color="primary"
              [ngModel]="deliveryOption.isEnabled"
              (change)="this.updateUserSetting(preferenceGroup.groupKey, preference.subGroupKey, deliveryOption.method, $event.checked)"
            >
              <div class="spacing--padding-right">
                {{ 'preferences.preferences-overview.delivery-option.' + deliveryOption.method | lowercase | translate }}
              </div>
            </mat-slide-toggle>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #noPreferenceGroups>
  <agr-notification-empty
    [isEmpty]="true"
    [emptyTitle]="'preferences.preferences-overview.empty-title' | translate"
    [emptyDescription]="'preferences.preferences-overview.empty-description' | translate"
    [showEmptyAction]="false"
  >
  </agr-notification-empty>
</ng-template>
